module.exports = __webpack_public_path__ + "static/media/slide-4.a36f9cb9.jpg";